import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../context/app.context";
import { ScheduleContext } from "../context/schedule.context";
import { ModelCxContext } from "../context/modelCx.context";
import Input from "../components/Input";
import { filterUserList } from "../utility/filterUserList";
import search from "./../assets/icons/search.svg";

export const UserListScreen = () => {
  const { awsgwUsersResult } = useContext(ModelCxContext);
  // Use TanStack users list directly. useMemo so the `[]` fallback is
  // reference-stable for downstream useEffect deps.
  const requestedUsersList = useMemo(
    () => awsgwUsersResult || [],
    [awsgwUsersResult]
  );
  const { userListQuery, setUserListQuery } = useContext(ScheduleContext);
  const { setOpenUserDetailModal } = useContext(AppContext);
  const [filteredUserList, setFilteredUserList] = useState([]);

  // - - - - - - - - - -

  const onSearch = () => {
    console.log("JobsHeader onSearch userListQuery: ", userListQuery);
  };

  // - - - - - - - - - -

  const handleRowClick = (user) => {
    console.log("JobsHeader handleRowClick user:", user);
    setOpenUserDetailModal({ show: true, currentUser: user });
  };

  // - - - - - - - - - - - - - - - - -  EFFECT HOOKS  - - - - - - - - - - - - - - - - - -
  //
  // requestedUsersList, userListQuery change  -> setFilteredUserList()
  //

  // - - - - - - - - - -

  useEffect(() => {
    // #198 — case-insensitive on ALL fields incl. username (was case-sensitive
    // on username only). Extracted to a pure, tested helper.
    setFilteredUserList(filterUserList(requestedUsersList, userListQuery));
  }, [requestedUsersList, userListQuery]);

  // - - - - - - - - - -

  return (
    <div className="flex flex-col px-4 pt-8 gap-4 h-full relative">
      {/* Users Count - Upper Right */}
      <div className="absolute top-2 right-4 bg-gray-100 border border-gray-300 rounded px-3 py-2 text-xs z-10">
        <span className="text-gray-600">Users:</span>{' '}
        <span className="font-semibold" style={{ color: '#22c55e' }}>{requestedUsersList?.length || 0}</span>
      </div>

      <div className="h-6 max-w-md">
        <Input
          className="bg-yellow-30 text-black"
          placeholder="Search by email, company, or location"
          value={userListQuery}
          onChange={(e) => setUserListQuery(e.target.value)}
          onEnter={() => onSearch()}
        >
          <Input.Suffix>
            <button className="w-6" onClick={() => onSearch()}>
              <img src={search} alt="search" />
            </button>
          </Input.Suffix>
        </Input>
      </div>
      <div className="table-container">
        <table className="sch-grid">
          <thead>
            <tr>
              <th>Email</th>
              <th>Default Company</th>
              <th>Location</th>
              {/* Add more columns as needed */}
            </tr>
          </thead>
          <tbody>
            {filteredUserList?.map((user) => (
              <tr
                key={user._id}
                className="cursor-pointer hover:bg-yellow-30"
                onClick={() => handleRowClick(user)}
              >
                <td>{user.username}</td>
                <td>{user.defaultCompany}</td>
                <td>{user.defaultLocation}</td>
                {/* Add more fields as needed */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
